import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import Store from "./redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_ENV === "production") {
  // console.log = () => {};
  // console.error = () => {};
  // console.debug = () => {};
  // console.warn = () => {};
}

const persistStore = Store();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,
  environment: process.env.REACT_APP_ENV,

  tracesSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration({
      enableLongTask: true,
      enableInp: true,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  debug: process.env.REACT_APP_ENV === "development",
});

const SentryWrappedApp = Sentry.withErrorBoundary(App, {
  fallback: <div>An error has occurred</div>,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={persistStore.store}>
    {/* <PersistGate persistor={persistStore.persistor}> */}
    <SentryWrappedApp />
    {/* </PersistGate> */}
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
